import { c as _c } from "react/compiler-runtime";
import { FaroTextButton } from "@components/common/faro-text-button";
import { SphereAvatar } from "@components/header/sphere-avatar";
import { ChevronRightIcon, Text, Divider } from "@flat-ui";
import { Box, Grid } from "@mui-wrapper";
import { AccountSettingsMobileHeader } from "@pages/account-settings/account-settings-layout/mobile-layout/account-settings-mobile-header";
import { useAccountSettingsMobileMenu } from "@pages/account-settings/account-settings-layout/mobile-layout/use-account-settings-mobile-menu";
import { useUserContext } from "@pages/account-settings/user-provider";
import { DEFAULT_INPUT_FONT_SIZE, withEllipsisTwoLines } from "@styles/common-styles";
import { OpenTabEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { getPrettyName, getUserInitials } from "@utils/user-utils";
import { LogoutButtonMobile } from "@pages/account-settings/account-settings-layout/mobile-layout/logout-button-mobile";
import { useAppSelector } from "@store/store-helper";
import { isUserLoggedInSelector } from "@store/user/user-selector";
/** The mobile layout for account settings tab selection */
export function AccountSettingsMobileTabSelection(t0) {
  const $ = _c(38);
  const {
    tabs
  } = t0;
  const {
    user
  } = useUserContext();
  const {
    closeTabSelection
  } = useAccountSettingsMobileMenu();
  const {
    trackEvent
  } = useTrackEvent();
  const isUserLoggedIn = useAppSelector(isUserLoggedInSelector);
  if (!user) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      flexWrap: "nowrap",
      alignItems: "center"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = user.thumbnailUrl;
  let t3;
  if ($[1] !== user) {
    t3 = getUserInitials(user);
    $[1] = user;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3 || $[4] !== user.thumbnailUrl) {
    t4 = <SphereAvatar src={t2} initials={t3} icon={undefined} shouldUseSimplifiedAvatar={false} shouldHideWhiteRim={true} size="large" />;
    $[3] = t3;
    $[4] = user.thumbnailUrl;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      ml: "20px",
      flexDirection: "column"
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      color: "text.primary",
      ...withEllipsisTwoLines
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== user) {
    t7 = getPrettyName(user);
    $[8] = user;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t7) {
    t8 = <Text variant="bodyM" sx={t6}><var>{t7}</var></Text>;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      color: "text.secondary",
      ...withEllipsisTwoLines
    };
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== user.email) {
    t10 = <Text variant="bodyS" sx={t9}><var>{user.email}</var></Text>;
    $[13] = user.email;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t8) {
    t11 = <Grid container={true} sx={t5}>{t8}{t10}</Grid>;
    $[15] = t10;
    $[16] = t8;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t4) {
    t12 = <Grid container={true} sx={t1}>{t4}{t11}</Grid>;
    $[18] = t11;
    $[19] = t4;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== closeTabSelection || $[22] !== t12) {
    t13 = <AccountSettingsMobileHeader menuLabel="Close Account Settings menu" onMenuClick={closeTabSelection}>{t12}</AccountSettingsMobileHeader>;
    $[21] = closeTabSelection;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      mt: "40px",
      mx: "15px"
    };
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== tabs) {
    t15 = Object.values(tabs);
    $[25] = tabs;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== isUserLoggedIn || $[28] !== t15 || $[29] !== trackEvent) {
    t16 = t15.map((tab, index) => <FaroTextButton key={index} sx={{
      color: "text.primary",
      fontSize: DEFAULT_INPUT_FONT_SIZE,
      p: "8px",
      mb: "8px",
      width: "100%",
      justifyContent: "space-between"
    }} endIcon={<ChevronRightIcon />} to={tab.routeId} onClick={() => {
      trackEvent({
        name: OpenTabEvents.openAccountSettingsTab,
        props: {
          isUserLoggedIn,
          tab: tab.routeId
        }
      });
    }}>{tab.label}</FaroTextButton>);
    $[27] = isUserLoggedIn;
    $[28] = t15;
    $[29] = trackEvent;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  let t18;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Divider sx={{
      my: "10px"
    }} />;
    t18 = <LogoutButtonMobile />;
    $[31] = t17;
    $[32] = t18;
  } else {
    t17 = $[31];
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t16) {
    t19 = <Box sx={t14}>{t16}{t17}{t18}</Box>;
    $[33] = t16;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t13 || $[36] !== t19) {
    t20 = <>{t13}{t19}</>;
    $[35] = t13;
    $[36] = t19;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  return t20;
}